import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import * as yup from "yup";
import { Base64 } from "js-base64";

import { setToken, setTokenIdentifier, setTokenUser } from "services/auth";
import { GetUserInfo, GetUserInfoCIF } from "services/user";
import { useFilterData } from "hooks/useFilterData";

export default function Auth() {
  const authKey = useParams("/auth/:key");
  const navigate = useNavigate();
  const [timeout, setTimeout] = useState("");

  const filterData = useFilterData();

  localStorage.clear();

  const LoadUserInfo = async (token, identifier, user) => {
    await GetUserInfo(token, identifier, user);

    const cifs = await GetUserInfoCIF(token, identifier, user);

    if (cifs === null) {
      navigate("/unauthorized", { replace: true });
    }

    filterData.SetCIFList(cifs);
  };

  useEffect(() => {
    try {
      const rule = yup.string().min(1);

      if (authKey === undefined || authKey === null) {
        navigate("/unauthorized", { replace: true });
      } else if (rule.isValidSync(authKey.key) === false) {
        navigate("/unauthorized", { replace: true });
      } else {
        const key = Base64.decode(authKey.key);

        if (rule.isValidSync(key) === true) {
          const ruleArray = yup.array().length(3);

          const values = key.split("|");

          if (ruleArray.isValidSync(values) === true) {
            setToken(values[0]);
            setTokenIdentifier(values[1]);
            setTokenUser(values[2]);

            LoadUserInfo(values[0], values[1], values[2]).finally(() => {
              setTimeout(() => {
                setTimeout("ok");
              }, 1000);
            });
          }
        }
      }

      navigate("/unauthorized", { replace: true });
    } catch (error) {
      navigate("/unauthorized", { replace: true });
    }
  }, []);

  useEffect(() => {
    if (timeout === "ok") {
      navigate("/", { replace: true });
    }
  }, [timeout]);

  return <></>;
}
